module.exports = __webpack_public_path__ + "static/media/BUSD.8705fd81.svg";